// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"3b1f751a","126":"c96309e7","171":"68afd063","239":"cec163cd","378":"149fd49b","389":"e95599ae","453":"2a12bf63","732":"69e96957","977":"dfb3611d"}[chunkId] + ".chunk.js";
};